<template lang="pug">
#laudos-conformidade-ambiental
    template(slot='title')
        .dialog-header
            | {{ $t('laudos.conformidadeAmbientalDoCar') }}
    slot
    .modal-container-inner-filtros
        .filtro-tipo-consulta
            p.title
                | {{ $t('laudos.selecioneTipoDeInsumoParaCriacaoDeLaudo') }}
            el-radio-group.radio-group-container(
                v-model='tipoBusca',
                @change='onChangeHandle'
            )
                el-radio.radio-button(label='CAR') CAR
                el-radio.radio-button(
                    label='TERRITORIO',
                    :disabled='desabilitarTerritorio(usuarioLogado)'
                ) {{ $t('laudos.territorio') }}
            #idTerritorio.busca.none
                SelecionarTerritorio(
                    :tipoLaudo='tipoLaudo',
                    @getTerritoriosSelecionados='solicitarLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio',
                    ref='selecionarTerritorio'
                )
            #idCar.busca
                SelecionarCar(
                    :tipoLaudo='tipoLaudo',
                    @getLaudos='getLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio'
                )
</template>

<script>
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio.vue';
import SelecionarCar from '@/modules/laudos/components/SelecionarCar.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import LaudoService from '@/modules/laudos/services/LaudosService';
import { mapGetters } from 'vuex';

export default {
    name: 'LaudoConformidadeAmbientalModal',
    components: {
        SelecionarTerritorio,
        SelecionarCar
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.CONFORMIDADE,
            showModalSelecionarTerritorios: false,
            idLaudo: null,
            laudos: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                car: '',
                territoriosIds: [],
                tipoLaudoId: TipoLaudo.CONFORMIDADE
            },
            rowInfo: null,
            totalLaudos: 0,
            usuariosBuffer: {},
            showModalInsercaoResultados: false,
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR'
        };
    },
    mounted() {
        this.getLaudos();
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        changeShowModalSelecionarTerritorio() {
            this.showModalSelecionarTerritorios =
                !this.showModalSelecionarTerritorios;
            this.showBusca();
            this.$emit('showModalSelecionarTerritorios');
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            this.$router.push({
                name: 'LaudoSolicitacaoConformidadeAmbiental',
                params: { idsTerritorio }
            });
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudoService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },

        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        onChangeHandle() {
            this.showBusca();
        },

        showBusca() {
            if (this.tipoBusca === 'CAR') {
                $('#idTerritorio').addClass('none');
                $('#idCar').removeClass('none');
            } else {
                $('#idCar').addClass('none');
                $('#idTerritorio').removeClass('none');
            }
        },

        desabilitarTerritorio(usuarioLogado) {
            if (usuarioLogado && usuarioLogado.authorities.length > 1) {
                return false;
            } else {
                if (
                    usuarioLogado.authorities[0].authority ===
                    'ROLE_FEATURE_LAUDO'
                ) {
                    return true;
                }
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#laudos-conformidade-ambiental {
    #modal-conformidade {
        .dialog-header {
            background-color: #e9e9e9;
            color: #00413c;
            padding: 15px;
            margin: -20px -20px 20px -20px;
            font-size: 18px;
            font-weight: 600;
            border-radius: 5px, 5px, 0px, 0px;
            box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
        }
        .el-dialog__body {
            max-height: 525px;
            padding: 15px;
        }
    }
    .laudo-margin {
        margin-bottom: 20px;
    }

    .selecionados,
    .nao-selecionados {
        display: flex;
        flex-direction: column;

        .el-checkbox {
            width: 100%;
            display: flex;
            align-items: center;

            .el-checkbox__label {
                display: flex;
                flex-direction: column;

                p {
                    line-height: 16px;
                }
            }

            em {
                font-weight: 200;
                font-size: 12px;
            }
        }
    }

    .lista {
        background: var(--white);
        border-radius: 4px;
        overflow: hidden;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .radio-group-container {
        max-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .none {
        display: none !important;
    }
}
</style>
